module.exports = __webpack_public_path__ + "img/nodata.5f55c67e.png";